import { render, staticRenderFns } from "./RegistrationInfo.vue?vue&type=template&id=459a8708"
import script from "./RegistrationInfo.vue?vue&type=script&lang=ts"
export * from "./RegistrationInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports